import React from 'react'
import { withTheme } from '@emotion/react'

const GlobalStyles = withTheme(() => <></>)

export default GlobalStyles
